import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 9m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0","key":"svg-0"}],["path",{"d":"M12 14v7","key":"svg-1"}],["path",{"d":"M7 18h10","key":"svg-2"}]]

const IconGenderFemme = createReactComponent('outline', 'gender-femme', 'GenderFemme', __iconNode);

export default IconGenderFemme;